import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Button, Form, Input } from 'antd';
import { useRef, useState } from 'react';

/**
 * Champ « nouveau style » des onglets de styles. Un nom vide ne crée rien : le
 * champ passe en erreur et reprend le focus, au lieu d'une alerte navigateur.
 */
const NewStyleInput = ({ onAdd, loading, style }) => {
  const [name, setName] = useState('');
  const [missingName, setMissingName] = useState(false);
  const inputRef = useRef(null);

  const submit = () => {
    const trimmed = name.trim();
    if (!trimmed) {
      setMissingName(true);
      inputRef.current?.focus();
      return;
    }
    onAdd(trimmed);
    setName('');
  };

  return (
    <div style={{
      margin: '2rem 0', padding: '0 2rem', display: 'flex', alignItems: 'flex-start', width: '100%', ...style,
    }}>
      <Form.Item
        style={{ flex: 1, marginBottom: 0, textAlign: 'left' }}
        validateStatus={missingName ? 'error' : undefined}
        help={missingName ? 'Donnez un nom au style' : undefined}
      >
        <Input
          ref={inputRef}
          placeholder='Nom du nouveau style'
          value={name}
          onChange={(e) => {
            setName(e.target.value);
            setMissingName(false);
          }}
          onPressEnter={submit}
        />
      </Form.Item>
      <Button
        type='primary'
        loading={loading}
        style={{ marginLeft: '.5rem' }}
        onMouseDown={(e) => e.preventDefault()}
        onClick={submit}
      >
        <FontAwesomeIcon icon={icon({ name: 'plus', style: 'light' })} style={{ fontSize: '1.5em' }} />
      </Button>
    </div>
  );
};

export default NewStyleInput;
